import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 9c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "10.5",
  cy: "9",
  r: ".5"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "13.5",
  cy: "9",
  r: ".5"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "12",
  cy: "9",
  r: ".5"
}, "3")], 'MonitorWeightRounded');